import { AppContext } from 'contexts/AppContext'
import { useContext, useEffect, useState } from 'react'
import { trackEvent } from 'utils/Analytics'
import { isRunningSpecs } from 'components/experiments'

export { Experiment, Variant } from 'react-optimize'

export const Default = () => {
  return null
}

type UseExperimentOptions = {
  id: string
  isActive?: boolean
  activationEvent?: string
}

type Experiment = {
  id: string
  variant?: string
  isReady: boolean
  isActive: boolean
}

let experiments = {}

export const useExperiment = ({ id, isActive, activationEvent }: UseExperimentOptions) => {
  const { domain } = useContext(AppContext)
  const [experiment, setExperiment] = useState<Experiment>(
    experiments[id] || {
      variant: null,
      isReady: false,
      isActive: false,
    }
  )

  useEffect(() => {
    // Cypress runs e2e specs via Electron. Never run for Cypress.
    if (!isActive || isRunningSpecs()) {
      setExperiment({ id, variant: null, isReady: true, isActive: false })
      return
    }

    let timeoutId = setTimeout(() => {
      trackEvent(domain, 'optimize', { type: 'timeout' })
      setExperiment((experiment) => ({ ...experiment, isReady: true }))
    }, 4000)

    if (activationEvent) {
      window.dataLayer.push({ event: activationEvent })
    }

    gtag('event', 'optimize.callback', {
      name: id,
      callback: (variant: string) => {
        clearTimeout(timeoutId)
        trackEvent(domain, 'optimize', { type: 'complete' })
        setExperiment({ id, variant, isReady: true, isActive })
      },
    })

    return () => clearTimeout(timeoutId)
  }, [id, isActive, activationEvent])

  return experiment
}

declare global {
  interface Window {
    google_optimize: any
  }
}
